<template>
	<img
		:src="$store.state.moduleSetting.navbarColor === '#fff' ? logoDark : logoLight"
		class=""
		width="150"
		height="50"
	/>
</template>
<script>
export default {
	data() {
		return {
			logoLight: require("@/assets/images/pages/rutify/1-02.png"),
			logoDark: require("@/assets/images/pages/rutify/logorutify-dark.png"),
		};
	},
};
</script>
